// extracted by mini-css-extract-plugin
export default {"divider":"Notifications_divider__YjLrR"};